import React, {PureComponent} from 'react';
import Favicon from 'react-favicon';

import Form from 'components/Form';
import Input from 'components/Input';
import Button from 'components/Button';
import Loader from 'components/Loader';
import {Link} from 'react-router-dom';
import {getBrand} from '../../utils';

import emailIcon from './email-icon.svg';
import passwordIcon from './password-icon.svg';

import './login.css';

export default class LoginView extends PureComponent{
    componentWillMount(){
        document.title = `${this.renderBrandName()} Integrations`;
    }
    renderBrandName(){
        return getBrand() === 'circleloop' ? 'CircleLoop' : 'CloudTalk';
    }
    render(){
        return (
            <section className="cl-login">
                <Favicon url={`./${this.renderBrandName()}-favicon.ico`} />
                <Form onSubmit={this.props.onSubmit} className="cl-login-form">
                    <h1>{`${getBrand() === 'circleloop' ? 'CircleLoop' : 'CloudTalk'} Integrations`}</h1>
                    <p className="cl-login-form-text">Link your account with your existing business software</p>
                    <Input icon={emailIcon} required placeholder="Email" type="email" value={this.props.email} name="email" onChange={this.props.onChange}/>
                    <Input icon={passwordIcon} required type="password" placeholder="Password" value={this.props.password} name="password" onChange={this.props.onChange}/>
                    <Button disabled={this.props.loading} className="cl-login-submit" type="submit" styling={getBrand() === 'circleloop' ? 'turquoise' : 'cloudtalk'}>
                        <span>Login</span>
                        {this.props.loading ? <Loader type="1" size="16px"/> : null}
                    </Button>
                    <div className="cl-login-links row between-xs no-margin">
                        <Link to="/reset-password">Forgot password</Link>
                        {getBrand() === 'circleloop' ? <a href="https://www.circleloop.com">Sign up for an account</a> : null}
                    </div>
                </Form>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Login/view.js